import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ValueProps } from './components/ValueProps';
import { WhatsIncluded } from './components/WhatsIncluded';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { ForYouSection } from './components/ForYouSection';
import { ResultSection } from './components/ResultSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    const pixelId = '26257470350562748';
    // Initialize fbq function
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Load the Facebook Pixel script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Track PageView
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold-500 selection:text-navy-900" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ValueProps data-id="element-4" />
        <WhatsIncluded data-id="element-5" />
        <BonusSection data-id="element-6" />
        <ForYouSection data-id="element-7" />
        <ResultSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <Testimonials data-id="element-10" />
      </main>

      <footer className="bg-navy-900 py-8 border-t border-navy-800 text-center text-gray-500 text-sm" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} KIT Sesiones Clínicas. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-13">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>
    </div>;
}